// removed by extract-text-webpack-plugin
module.exports = {"cardAttachment":"HorizontalCardAttachment__cardAttachment__149bh","content":"HorizontalCardAttachment__content__ns0OM","icon":"HorizontalCardAttachment__icon__2A-Gs"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCardAttachment/HorizontalCardAttachment.scss
// module id = 1689
// module chunks = 0